import React, { FC, ReactNode } from 'react';
import styles from './ContractsFilterSection.module.scss';

export interface FilterSectionProps {
  children: ReactNode;
  variant?: 'section' | 'field';
  className?: string;
}

export const ContractsFilterSection: FC<FilterSectionProps> = ({
  children,
  variant = 'section',
  className,
}) => {
  const sectionClass = variant === 'field' ? styles.field : styles.section;

  return <div className={`${sectionClass} ${className || ''}`}>{children}</div>;
};
